<template>
  <div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      width="70%"
      @close="setDialogClosed"
      append-to-body
    >
      <el-container
        class="container"
        direction="vertical"
        style="height: 500px"
      >
        <ul style="overflow: auto; margin-right: 20px">
          <el-descriptions :column="4" border style="margin-bottom: 10px">
            <el-descriptions-item :span="2" label="住院次数">
              {{ detail.content.inCount }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="编号">
              {{ detail.healthNo }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="姓名">
              {{ detail.patientName }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="性别">
              {{ detail.gender }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="年龄">
              {{ detail.age }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="身份证号">
              {{ detail.idcard }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="联系电话">
              {{ detail.phone }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="居住住址">
              {{ detail.address }}
            </el-descriptions-item>

            <el-descriptions-item :span="4" label="入院途径">
              {{ detail.content.inWay }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="入院时间">
              {{ detail.content.inDate }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="入院科室">
              {{ detail.content.inDept }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="出院时间">
              {{ detail.content.outDate }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="出院科室">
              {{ detail.content.outDept }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="实际住院天数">
              {{ inHosDays }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="出院诊断">
              {{ detail.content.diagNames }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="主要治疗方式">
              {{ detail.content.treatment }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="出院院后病情转归">
              {{ detail.content.outWay }}{{detail.content.outToHospital==null?'':detail.content.outToHospital}}
            </el-descriptions-item>

            <el-descriptions-item :span="4" label="*症状">
              <el-radio v-model="symptomRadio" label="1">无</el-radio>
              <el-radio v-model="symptomRadio" label="2">有</el-radio>
              <el-checkbox-group
                v-if="symptomVisiable"
                v-model="detail.content.symptoms"
              >
                <el-checkbox
                  v-for="item in symptomList"
                  :label="item"
                  :key="item"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>

              <el-input
                v-model="detail.content.symptomOther"
                v-if="symptomVisiable"
                placeholder="其他症状"
                style="margin-top: 5px"
              ></el-input>

            </el-descriptions-item>

            <el-descriptions-item :span="4" label="体征">
              <el-descriptions :column="4" border>
                <el-descriptions-item :span="2" label="空腹血糖值(mmol/L)">
                  {{ detail.content.emptyGlu }}
                </el-descriptions-item>

                <el-descriptions-item :span="2" label="餐后血糖值(mmol/L)">
                  {{ detail.content.twohourGlu }}
                </el-descriptions-item>

                <el-descriptions-item :span="2" label="随机血糖值(mmol/L)">
                  {{ detail.content.randomGlu }}
                </el-descriptions-item>

                <el-descriptions-item :span="2" label="*身高(cm)">
                  {{ detail.content.height }}
                </el-descriptions-item>

                <el-descriptions-item :span="2" label="*体重(kg)">
                  {{ detail.content.weight }}
                </el-descriptions-item>

                <el-descriptions-item :span="2" label="*腰围(cm)">
                  {{ detail.content.waist }}
                </el-descriptions-item>

                <!-- <el-descriptions-item :span="2" label="体质指数">
                  <el-input v-model="detail.content.bmi"></el-input>
                </el-descriptions-item> -->

                <el-descriptions-item :span="2" label="*血压(mmHg)">
                  {{ detail.content.sbp }}/{{ detail.content.dbp }}
                </el-descriptions-item>

                <el-descriptions-item :span="2" label="足背动脉搏动">
                  {{ detail.content.dorsalisPedisPulse }}
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="生活方式指导">
              <el-descriptions :column="1" border>
                <el-descriptions-item span="4" label="日吸烟量(支/天)">
                  {{ detail.content.smokePerday }}
                </el-descriptions-item>

                <el-descriptions-item span="4" label="日饮酒量(两)">
                  {{ detail.content.drinkPerday }}
                </el-descriptions-item>

                <el-descriptions-item span="4" label="日吸烟量指导(支/天)">
                  {{ detail.content.smokePerdayTarget }}
                </el-descriptions-item>

                <el-descriptions-item span="4" label="日饮酒量指导">
                  <el-descriptions :colums="4" border>
                    <el-descriptions-item span="4" label="饮酒品类">
                      {{ detail.content.drinkType }}
                    </el-descriptions-item>

                    <el-descriptions-item
                      style="display: flex"
                      span="4"
                      label="饮酒量"
                    >
                      {{ detail.content.drinkPerdayTarget
                      }}{{ detail.content.drinkUnit }}
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item :span="4" label="运动基本情况">
                  <el-descriptions :colums="4" border>
                    <el-descriptions-item span="2" label="运动频次(次/周)">
                      {{ detail.content.sportFreq }}
                    </el-descriptions-item>

                    <el-descriptions-item span="2" label="运动时长(分钟/次)">
                      {{ detail.content.sportMinutesPertime }}
                    </el-descriptions-item>

                    <el-descriptions-item
                      span="2"
                      label="运动时是否有胸闷、胸痛不适感"
                    >
                      {{ detail.content.sportTired }}
                    </el-descriptions-item>

                    <el-descriptions-item
                      span="2"
                      label="运动过程中是否有过跌倒情况"
                    >
                      {{ detail.content.sportFall }}
                    </el-descriptions-item>

                    <el-descriptions-item
                      span="2"
                      label="运动过程中是否有低血糖情况"
                    >
                      {{ detail.content.sportBloodsugar }}
                    </el-descriptions-item>

                    <el-descriptions-item span="2" label="是否存在足底破溃">
                      {{ detail.content.sportFoot }}
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item :span="4" label="运动行为指导">
                  <el-descriptions :colums="4" border>
                    <el-descriptions-item span="2" label="运动形式">
                      {{ detail.content.sportType }}
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="运动时间">
                      {{ detail.content.sportPeriodGuides }}
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="运动时长">
                      {{ detail.content.sportMinutesPertimeTarget }}
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="运动频次">
                      {{ detail.content.sportFreqTarget }}
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>
                <el-descriptions-item span="4" label="饮食习惯">
                  <el-descriptions :colums="4" border>
                    <el-descriptions-item
                      span="4"
                      label="您是否了解饮食与血糖的影响"
                    >
                      {{ detail.content.knowDietSugar }}
                    </el-descriptions-item>

                    <el-descriptions-item
                      span="4"
                      label="您是否执行过糖尿病饮食"
                    >
                      {{ detail.content.obeyDiabetesDiet }}
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="您的三餐是否有规律">
                      {{ detail.content.dietRegular }}
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="您的口味偏好">
                      {{ detail.content.taste }}
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="您的饮食嗜好">
                      {{ detail.content.dietHobbies }}
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item span="4" label="饮食指导">
                  {{ detail.content.dietGuide }}
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="用药指导">
              <el-descriptions :column="4" border>
                <el-descriptions-item span="4" label="基本情况">
                  <el-descriptions :column="4" border>
                    <el-descriptions-item span="4" label="服药依从性">
                      {{ detail.content.medicationAdherence }}
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="药物不良反应">
                      {{ detail.content.medicationBadEvent }}
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="是否有药物过敏史">
                      {{ detail.content.allergy }}
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="低血糖反应">
                      {{ detail.content.hypoglycemiaReaction }}
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item span="4" label="目前用药情况">
                  <el-descriptions :column="1" border>
                    <el-descriptions-item
                      class="medicines"
                      label="用药"
                      v-for="(item, index) in detail.content.medicines"
                      :key="index"
                    >
                      <el-descriptions :column="4" border>
                        <el-descriptions-item span="2" label="药物名称">
                          {{ item.medicineName }}
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用药次数/日">
                          {{ item.freq }}
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用量/次">
                          {{ item.dosage }}
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用药时间">
                          {{ item.takeMethod }}
                        </el-descriptions-item>
                        <el-descriptions-item span="4" label="注意事项">
                          {{ item.remark }}
                        </el-descriptions-item>
                      </el-descriptions>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item span="4" label="用药调整指导">
                  <el-descriptions :column="1" border>
                    <el-descriptions-item
                      class="medicines"
                      label="用药"
                      v-for="(item, index) in detail.content.medicinesGuide"
                      :key="index"
                    >
                      <el-descriptions :column="4" border>
                        <el-descriptions-item span="2" label="药物名称">
                          {{ item.medicineName }}
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用药次数/日">
                          {{ item.freq }}
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用量/次">
                          {{ item.dosage }}
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用药时间">
                          {{ item.takeMethod }}
                        </el-descriptions-item>
                        <el-descriptions-item span="4" label="注意事项">
                          {{ item.remark }}
                        </el-descriptions-item>
                      </el-descriptions>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="随访人">
              {{ detail.content.doctorName }}
            </el-descriptions-item>

            <el-descriptions-item span="4" label="本次随访时间">
              {{ detail.content.followupTime }}
            </el-descriptions-item>

            <el-descriptions-item span="4" label="下次随访时间">
              {{ detail.content.nextFollowupTime }}
            </el-descriptions-item>
          </el-descriptions>
        </ul>
      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="showDialog = false"
          >关闭</el-button
        >
        <!-- <el-button type="primary" size="small" @click="submit()"
          >提交</el-button
        > -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  commitFollowUp,
  getMedicineList,
  getDeptList,
} from "@/api/health/Patients";
import pinyinMatch from "pinyin-match";

Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
export default {
  components: {},
  data() {
    return {
      symptomList: [
        "多饮",
        "多食",
        "多尿",
        "视力模糊",
        "感染",
        "手脚麻木",
        "下肢浮肿",
        "体重明显下降",
        "关节疼痛",
      ],
      showDialog: false,
      title: "出院患者随访表",
      restaurants: [],
      timeout: null,
      listLoading: false,
      symptomRadio: "2",
      medicationBadEventRadio: "2",
      symptomVisiable: false,
      medicationBadEventVisiable: false,
      sportTypeSelectDisable: false,
      outToHospitalVisiable: false,
      inHosDays: null,
      detail: {
        serviceName: "出院随访",
        patientName: null,
        phone: null,
        age: null,
        gender: null,
        address: null,
        medicationObey: "规律",
        medicationSideEffects: "无",
        content: {
          inCount: null,
          inWay: null,
          inDate: null,
          outDate: null,
          inDept: null,
          outDept: null,
          diagCodes: null,
          diagNames: null,
          treatment: null,
          outWay: null,
          outToHospital: null,
          symptoms: [],
          symptomOther: null,
          drinkUnit: "两/天",
          medicines: [
            {
              medicineName: "",
              freq: "",
              dosage: "",
              remark: "",
              takeMethod: "",
            },
          ],
          medicinesGuide: [
            {
              medicineName: "",
              freq: "",
              dosage: "",
              remark: "",
              takeMethod: "",
            },
          ],
          emptyGlu: "",
          twohourGlu: "",
          randomGlu: "",
          height: "",
          sbp: "",
          dbp: "",
          tg: "",
          weight: "",
          bmi: null,
          tc: "",
          waist: "",
          hdlc: "",
          ldlc: "",
          smokePerday: "0",
          smokePerdayTarget: "0",
          drinkPerday: "0",
          nextFollowupTime: "",
          dorsalisPedisPulse: "触及正常",
          drinkType: "啤酒",
          drinkPerdayTarget: "0",
          sportFreq: "",
          sportMinutesPertime: "",
          sportTired: "否",
          sportFall: "否",
          sportBloodsugar: "否",
          sportFoot: "否",
          sportType: "",
          sportPeriodGuides: "",
          sportMinutesPertimeTarget: "",
          sportFreqTarget: "",
          medicationAdherence: "规律",
          allergy: "无",
          hypoglycemiaReaction: "无",
          knowDietSugar: "是",
          obeyDiabetesDiet: "是",
          dietRegular: "是",
          taste: "荤",
          dietHobbies: "基本均衡",
          dietGuide: "",
          followupTime: "",
          bloodsugarTime: "",
          doctorName: "",
          medicationBadEvent: "",
        },
      },
      medicationAdherenceOptions: [
        {
          value: "规律",
          lebel: "规律",
        },
        {
          value: "间断",
          lebel: "间断",
        },
        {
          value: "服药",
          lebel: "服药",
        },
        {
          value: "不服药",
          lebel: "不服药",
        },
      ],
      hypoglycemiaReactionOptions: [
        {
          value: "无",
          label: "无",
        },
        {
          value: "偶尔",
          label: "偶尔",
        },
        {
          value: "频繁",
          label: "频繁",
        },
      ],
      dorsalisPedisPulseOptions: [
        {
          value: "触及正常",
          label: "触及正常",
        },
        {
          value: "减弱(双侧 左侧 右侧)",
          label: "减弱(双侧 左侧 右侧)",
        },
        {
          value: "消失(双侧 左侧 右侧)",
          label: "消失(双侧 左侧 右侧)",
        },
      ],
      drinkTypeList: [
        { label: "红酒", value: "红酒" },
        { label: "白酒", value: "白酒" },
        { label: "啤酒", value: "啤酒" },
      ],
      drinkUnitList: [
        { label: "两/天", value: "两/天" },
        { label: "瓶/天", value: "瓶/天" },
      ],
      dosageList: [
        { label: "上午", value: "上午" },
        { label: "下午", value: "下午" },
        { label: "晚上", value: "晚上" },
      ],
      sportTypeList: [
        { label: "无", value: "无" },
        { label: "慢走", value: "慢走" },
        { label: "快走", value: "快走" },
        { label: "慢跑", value: "慢跑" },
        { label: "游泳", value: "游泳" },
        { label: "跳绳", value: "跳绳" },
        { label: "太极拳", value: "太极拳" },
      ],
      sportMinutesEachList: [
        { label: "10分钟", value: "10分钟" },
        { label: "10-20分钟", value: "10-20分钟" },
        { label: "20-30分钟", value: "20-30分钟" },
        { label: "大于30分钟", value: "大于30分钟" },
      ],
      sportFreqList: [
        { label: "一次", value: "一次" },
        { label: "两次", value: "两次" },
        { label: "三次", value: "三次" },
        { label: "三次以上", value: "三次以上" },
      ],
      sportTiredList: [
        { label: "是", value: "是" },
        { label: "否", value: "否" },
      ],
      tasteList: [
        { label: "荤", value: "荤" },
        { label: "素", value: "素" },
        { label: "咸", value: "咸" },
        { label: "甜", value: "甜" },
      ],
      dietHobbiesList: [
        { label: "基本均衡", value: "基本均衡" },
        { label: "主食为主", value: "主食为主" },
        { label: "肉食为主", value: "肉食为主" },
        { label: "素食为主", value: "素食为主" },
        { label: "水产品为主", value: "水产品为主" },
      ],
      inWayOptionsList: [
        { label: "门诊", value: "门诊" },
        { label: "急诊", value: "急诊" },
        { label: "其他医疗机构转入", value: "其他医疗机构转入" },
        { label: "其他", value: "其他" },
      ],
      otherOptionsList: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
      ],
      codiagHospitalOptions: [],
      codiagDeptNameOptions: [],
    };
  },
  created() {
    this.getDept();
  },
  watch: {
    medicationBadEventRadio: {
      handler(newval) {
        if (newval == 2) {
          this.medicationBadEventVisiable = true;
        } else {
          this.medicationBadEventVisiable = false;
        }
      },
      immediate: true,
      deep: true,
    },
    symptomRadio: {
      handler(newval) {
        if (newval == 2) {
          this.detail.content.symptoms = [];
          this.symptomVisiable = true;
        } else {
          this.detail.content.symptoms = [];
          this.symptomVisiable = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async querySearchAsync(queryString, cb) {
      await this.loadAll(queryString);
      var restaurants = this.restaurants;
      var results = restaurants.filter((item) => {
        const name = item.value.toLowerCase();
        const match =
          pinyinMatch.match(name, queryString) || name.includes(queryString);
        return match;
      });

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    outWaySelectChange(value) {
      console.log("出院后病情转归：", value);
      if (value == "转其他医院住院，接收医疗机构名称") {
        this.outToHospitalVisiable = true;
      } else {
        this.outToHospitalVisiable = false;
        this.detail.outToHospital = null;
      }
    },
    loadAll(value) {
      var params = { name: value };
      getMedicineList(params)
        .then((res) => {
          if (res.msg == "success") {
            res.data.records.forEach((item) => {
              this.restaurants.push({
                value: item.name,
                address: item.name,
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sportTypeSelectChange(e) {
      console.log(e);
      if (e == "无") {
        this.sportTypeSelectDisable = true;
      } else {
        this.sportTypeSelectDisable = false;
      }
    },
    // 编辑初始化页面内容
    async init(dataContext) {
      console.log("dataContext:", dataContext);
      if (dataContext) {
        this.detail = dataContext;
      }
      // this.detail.idcard = dataContext.idcard;
      // this.detail.phone = dataContext.phone;
      this.detail.healthNo = dataContext.healthNo
        ? dataContext.healthNo.substr(dataContext.healthNo.length - 8)
        : "--";
      // this.detail.patientName = dataContext.name;
      // this.detail.address = dataContext.address;
      // this.detail.gender = this.getGender(dataContext.gender);
      this.detail.age = this.getAge(dataContext.birthday);
      // this.detail.content.inDate = dataContext.inTime;
      // this.detail.content.inDept = dataContext.deptName;
      // this.detail.content.outDate = dataContext.outTime;
      // this.detail.content.inCount = dataContext.visitTimes;
      this.inHosDays = this.getInHosDays();

      //   this.detail.content.nextFollowupTime = dataContext.nextFollowupTime;
      //   this.detail.content.emptyGlu = dataContext.bloodSuger[0]?.value
      //     ? dataContext.bloodSuger[0].value
      //     : "--";
      //   this.detail.content.twohourGlu = dataContext.bloodSuger[1]?.value
      //     ? dataContext.bloodSuger[1].value
      //     : "--";
      //   this.detail.content.randomGlu = dataContext.bloodSuger[2]?.value
      //     ? dataContext.bloodSuger[2].value
      //     : "--";
      //   this.detail.content.doctorName = this.$store.getters.name;

      this.getSystemTime();
      this.showDialog = true;
    },
    // 青岛市黄岛区区立医院科室列表
    getDept() {
      //青岛市黄岛区区立医院
      var params = {
        parentId: 145,
      };
      getDeptList(params)
        .then((res) => {
          if (res.msg == "success") {
            res.data.records.forEach((item) => {
              this.codiagDeptNameOptions.push({
                label: item.name,
                value: item.name,
                deptId: item.deptId,
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getGender(sex) {
      if (sex == 1) {
        return "男";
      } else if (sex == 2) {
        return "女";
      } else {
        return "未说明的性别";
      }
    },
    //计算实际住院天数
    getInHosDays() {
      if (
        this.detail.content.inDate != null &&
        this.detail.content.outDate != null
      ) {
        let startTime = new Date(
          Date.parse(this.detail.content.inDate.replace(/-/g, "/"))
        ).getTime();
        let endTime = new Date(
          Date.parse(this.detail.content.outDate.replace(/-/g, "/"))
        ).getTime();
        let dates = Math.abs(startTime - endTime) / (1000 * 60 * 60 * 24);
        return dates.toFixed(0);
      } else {
        return null;
      }
    },
    // 计算年齡
    getAge(birthday) {
      if (birthday == null) return "";
      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
        (d.getMonth() == birthdays.getMonth() &&
          d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
    // 关闭对话框触发
    setDialogClosed() {
      this.sportTypeSelectDisable = false;
      this.detail = {
        serviceName: "出院随访",
        patientName: null,
        phone: null,
        age: null,
        gender: null,
        address: null,
        medicationObey: "规律",
        medicationSideEffects: "无",
        content: {
          inCount: null,
          inWay: null,
          inDate: null,
          outDate: null,
          inDept: null,
          outDept: null,
          diagCodes: null,
          diagNames: null,
          treatment: null,
          outWay: null,
          outToHospital: null,
          symptoms: [],
          symptomOther: null,
          drinkUnit: "两/天",
          medicines: [
            {
              medicineName: "",
              freq: "",
              dosage: "",
              remark: "",
              takeMethod: "",
            },
          ],
          medicinesGuide: [
            {
              medicineName: "",
              freq: "",
              dosage: "",
              remark: "",
              takeMethod: "",
            },
          ],
          emptyGlu: "",
          twohourGlu: "",
          randomGlu: "",
          height: "",
          sbp: "",
          dbp: "",
          tg: "",
          weight: "",
          bmi: null,
          tc: "",
          waist: "",
          hdlc: "",
          ldlc: "",
          smokePerday: "0",
          smokePerdayTarget: "0",
          drinkPerday: "0",
          nextFollowupTime: "",
          dorsalisPedisPulse: "触及正常",
          drinkType: "啤酒",
          drinkPerdayTarget: "0",
          sportFreq: "",
          sportMinutesPertime: "",
          sportTired: "否",
          sportFall: "否",
          sportBloodsugar: "否",
          sportFoot: "否",
          sportType: "",
          sportPeriodGuides: "",
          sportMinutesPertimeTarget: "",
          sportFreqTarget: "",
          medicationAdherence: "规律",
          allergy: "无",
          hypoglycemiaReaction: "无",
          knowDietSugar: "是",
          obeyDiabetesDiet: "是",
          dietRegular: "是",
          taste: "荤",
          dietHobbies: "基本均衡",
          dietGuide: "",
          followupTime: "",
          bloodsugarTime: "",
          doctorName: "",
          medicationBadEvent: "",
        },
      };
      this.showDialog = false;
    },
    addDrug() {
      var drugItem = {
        medicineName: "",
        freq: "",
        dosage: "",
        remark: "",
        takeMethod: "",
      };
      this.detail.content.medicines.push(drugItem);
    },
    deleteDrug(index) {
      this.detail.content.medicines.splice(index, 1);
    },
    addDrugGuide() {
      var drugItem = {
        medicineName: "",
        freq: "",
        dosage: "",
        remark: "",
        takeMethod: "",
      };
      this.detail.content.medicinesGuide.push(drugItem);
    },
    deleteDrugGuide(index) {
      this.detail.content.medicinesGuide.splice(index, 1);
    },
    submit() {
      if (!this.detail.content.height) {
        this.$message({
          message: "请输入身高！",
          type: "error",
        });
        return;
      }

      if (!this.detail.content.sbp) {
        this.$message({
          message: "请输入收缩压！",
          type: "error",
        });
        return;
      }

      if (!this.detail.content.dbp) {
        this.$message({
          message: "请输入舒张压！",
          type: "error",
        });
        return;
      }

      if (!this.detail.content.weight) {
        this.$message({
          message: "请输入体重！",
          type: "error",
        });
        return;
      }

      if (!this.detail.content.waist) {
        this.$message({
          message: "请输入腰围！",
          type: "error",
        });
        return;
      }

      if (!this.detail.content.smokePerday) {
        this.$message({
          message: "请输入生活方式指导中日吸烟量！",
          type: "error",
        });
        return;
      }

      if (!this.detail.content.smokePerdayTarget) {
        this.$message({
          message: "请输入生活方式指导中日吸烟量指导！",
          type: "error",
        });
        return;
      }

      if (!this.detail.content.drinkPerday) {
        this.$message({
          message: "请输入生活方式中日饮酒量！",
          type: "error",
        });
        return;
      }

      if (!this.detail.content.drinkPerdayTarget) {
        this.$message({
          message: "请输入生活方式日饮酒量指导中饮酒量！",
          type: "error",
        });
        return;
      }

      if (!this.detail.content.sportFreq) {
        this.$message({
          message: "请输入运动基本情况中运动频次！",
          type: "error",
        });
        return;
      }

      if (!this.detail.content.sportMinutesPertime) {
        this.$message({
          message: "请输入运动基本情况中运动时长！",
          type: "error",
        });
        return;
      }

      if (!this.detail.content.sportType) {
        this.$message({
          message: "请选择运动行为指导中运动形式！",
          type: "error",
        });
        return;
      }

      if (this.sportTypeSelectDisable == false) {
        if (!this.detail.content.sportPeriodGuides) {
          this.$message({
            message: "请选择运动行为指导中运动时间！",
            type: "error",
          });
          return;
        }

        if (!this.detail.content.sportMinutesPertimeTarget) {
          this.$message({
            message: "请选择运动行为指导中运动时长！",
            type: "error",
          });
          return;
        }

        if (!this.detail.content.sportFreqTarget) {
          this.$message({
            message: "请选择运动行为指导中运动频次！",
            type: "error",
          });
          return;
        }
      }

      if (!this.detail.content.dietGuide) {
        this.$message({
          message: "请输入饮食指导！",
          type: "error",
        });
        return;
      }

      this.detail.content.bmi = Number(
        this.detail.content.weight /
          Math.pow(this.detail.content.height / 100, 2)
      ).toFixed(2);

      let params = this.detail;
      console.log("======参数=====", this.detail);
      commitFollowUp(params)
        .then((res) => {
          if (res.msg == "success") {
            this.$message({
              message: "新建随访成功！",
              type: "success",
            });
            this.showDialog = false;
          } else if (res.code == "500") {
            this.$message({
              message: res.msg,
              type: "error",
            });
          } else {
            this.$message({
              message: "新建随访失败！",
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取系统时间
    getSystemTime() {
      // 实例化日期类
      var time = new Date();
      // 获取完整的年份(4位)
      var year = time.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = time.getMonth();
      // 获取日期(1-31)
      var date = time.getDate();
      var hour = time.getHours();
      var minute = time.getMinutes();
      var second = time.getSeconds();
      //测试打印
      console.log(year + "年" + month + "月" + date + "日 ");
      time.setFullYear(year, month, date);
      time.setHours(hour, minute, second);

      this.detail.content.followupTime = time.Format("yyyy-MM-dd hh:mm:ss"); //yyyy-MM-dd'T'HH:mm:ss.SSSZ
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  height: 500px !important;
  overflow: auto !important;
}

::v-deep {
  .el-dialog {
    margin-top: 5vh !important;
  }

  .el-descriptions-item__label.is-bordered-label {
    width: 100px;
  }

  .el-checkbox-group {
    width: 100px;
  }
}
</style>